exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-details {\n  margin: 1em auto;\n  width: 1000px;\n  height: 400px;\n  background: white;\n  clear: both;\n  position: relative; }\n  .employee-details table {\n    margin: 1em 2em;\n    border-collapse: collapse; }\n    .employee-details table td {\n      border-bottom: 1px solid #aaaaaa;\n      padding: .5em; }\n      .employee-details table td .button-link {\n        padding: .4em .5em;\n        background-color: white;\n        border: 1px solid #cfcfcf;\n        display: inline-block;\n        cursor: pointer;\n        margin: .2em;\n        text-decoration: none;\n        color: #363636; }\n  .employee-details .controls-container {\n    position: absolute;\n    top: 2em;\n    right: 2em;\n    float: right;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; }\n    .employee-details .controls-container a {\n      color: #656565;\n      font-size: .5em;\n      margin: 0 .2em;\n      cursor: pointer;\n      text-decoration: none; }\n      .employee-details .controls-container a:hover {\n        color: #363636; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/employees/views/employeeDetailsView/employeeDetailsView.component.scss
// module id = ./src/app/modules/employees/views/employeeDetailsView/employeeDetailsView.component.scss
// module chunks = main